export default Object.freeze({
  FormField: 'form-field',
  Variable: 'variable',
  FixedValue: 'fixed-value',
});
